// extracted by mini-css-extract-plugin
export default {"padded":"StripeButton-module__padded___3739i"};